const ensureArray = (value: any) => (Array.isArray(value) ? value : [value]);

export default ensureArray;
